import * as R from 'ramda';
import {
  OrderProductForGridContainerTransformer,
  OrderProductGridContainerProps,
} from '../../../../../orders/products/product/grid/components/orderProductGrid/components/grid/types/orderProductGridContainer.types';
import { ProductDetailsCombinationColorAndTagsProps } from '../../ProductDetailsCombinationColorAndTags/types/productDetailsCombinationColorAndTags.types';
import {
  ToOrderProductGridContainerParams,
  ToProductDetailsCombinationColorAndTagsParams,
} from '../types/combinationLineTransformer.types';

export class CombinationLineTransformer {
  static toProductDetailsCombinationColorAndTagsProps({
    combination,
    suggestedGrid,
    showSuggestedGrid,
    availabilityLabel,
    showColorIcon = true,
    showProductName = false,
    onClickProductName,
  }: ToProductDetailsCombinationColorAndTagsParams): ProductDetailsCombinationColorAndTagsProps {
    return {
      showColorIcon,
      onClickProductName,
      availability: combination.availability,
      availabilityLabel: availabilityLabel,
      showSuggestedGrid: showSuggestedGrid,
      productId: combination.productId,
      productColorId: combination.productColorId,
      productName: showProductName ? combination.productName : undefined,
      productColorName: combination.productColorName,
      productColorCode: combination.productColorCode,
      productColorHexCode: combination.productColorHexCode,
      productColorImageUrl: combination.productColorImageUrl,
      deliveryWindowEndDate: combination.deliveryWindowEndDate,
      deliveryWindowStartDate: combination.deliveryWindowStartDate,
      suggestedGridQuantity: R.sum(suggestedGrid.map((item) => item.orderItemQuantity ?? 0)),
    };
  }

  static toOrderProductGridContainerProps({
    combination,
    combinationKey,
    onClickPaste,
    removeCopiedGrid,
    resetSelectedPacks,
    stackOrderItem,
    ...commonProps
  }: ToOrderProductGridContainerParams): OrderProductGridContainerProps {
    return {
      ...commonProps,
      handleClickPaste: async () => await onClickPaste?.(),
      product: {
        ...OrderProductForGridContainerTransformer.fromProductDetails({
          ...combination,
        }),
        combinationKey,
      },
      removeCopiedGrid: () => removeCopiedGrid?.(),
      resetSelectedPacks: () => resetSelectedPacks?.(),
      stackOrderItem: (item) => stackOrderItem?.(item),
    };
  }
}
